(ns measure.resource.report
  (:require [camel-snake-kebab.core :as csk]
            [camel-snake-kebab.extras :as cske]
            [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.report/queue-report
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ {:keys [type params]}]]
    (let [url-template (case type
                         :adset_summary :measure-api/adset-summary-report
                         :impression_context :measure-api/adset-impression-context-report
                         :split_tests :measure-api/adset-split-tests-report
                         :product_store :measure-api/adset-product-store-report
                         :vast_adset_summary :measure-api/vast-adset-summary-report
                         :vast_split_tests :measure-api/vast-adset-split-tests-report
                         :vast_custom :measure-api/vast-custom-report
                         :custom :measure-api/custom-report)]
      {:fx [[:http
             {:method :post
              :uri (url-tpl/render url-template url-context)
              :params (->> (merge params (select-keys url-context [:advertiser-id]))
                           (cske/transform-keys csk/->snake_case))
              :headers {"Authorization" (:resource.user/token cofx)}
              :on-success [:resource.report/queue-report-success]
              :on-failure [:resource.report/queue-report-failure]}]]})))

(rf/reg-event-db :resource.report/queue-report-success
  identity)

(rf/reg-event-db :resource.report/queue-report-failure
  identity)
